
const NoFrame = () => {

  return (
    <div>No render</div>
  );
};

export default NoFrame;
